import styled from 'styled-components';
import { theme, Row, Column, Text } from '@dls/web';

export const StyledRow = styled(Row)`
  min-height: 65px;

  ${Column}:first-child {
    text-align: left;
    display: flex;
    flex-direction: row;
    ${(props) => props.isMobileView && `justify-content: center;`}

    & > div {
      text-transform: uppercase;
      cursor: pointer;
      margin: 0px 12px;
    }
  }
  ${Column}:last-child {
    text-align: right;
  }
`;

export const StyledText = styled(Text)`
  color: ${theme.main.colours.tertiary.l4};
  font-size: 12px;
`;
